import axios from 'axios';

export const authenticate = (data, next) => {
    const JSONData = JSON.stringify(data);
    if (typeof window !== "undefined") {
        localStorage.setItem("jwt", JSONData);
        next();
    }
}

export const signout = (next) => {
    if (typeof window !== "undefined") {
        localStorage.removeItem("jwt");
        next();
        return axios.get(`/api/users/auth/signout`)
            .then(res => {
                console.log(res);
            })
            .catch(err => {
                console.log(err);
            });
    }
}

export const isAuthenticated = () => {
    if (typeof window == "undefined") {
        return false;
    }
    if (localStorage.getItem('jwt')) {
        return JSON.parse(localStorage.getItem('jwt'));
    } else {
        return false;
    }
}

export const uploadFiles = (file, postId) => {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("postId", postId);
    return axios.post("/postimage/create", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

export const uploadExcelFile = (file, excel, onUploadProgress) => {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/uploadexcel", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    });
}

